import { TFunction } from 'i18next';
import { z } from 'zod';

import { InternalRateType } from '@/modules/team';

/**
 * Validation schema for team member billing form with i18n support.
 * Ensures data integrity for team member billing information.
 *
 * @param t - i18n translation function
 * @param options - Optional configuration for schema validation
 * @param options.requireInternalRate - Whether internal rate fields are required (default: true)
 * @returns Zod schema with localized error messages
 */
export const teamMemberBillingSchema = (
  t: TFunction,
  options?: { requireInternalRate?: boolean }
) => {
  const { requireInternalRate = true } = options || {};

  return z.object({
    // Internal rate fields
    internalRateType: z.nativeEnum(InternalRateType).optional(),
    internalRateCurrency: requireInternalRate ? z.string() : z.string().optional(),
    internalRate: z.number().min(0, t('common:error.cannotBeNegative')).optional(),

    // External rate fields
    externalHourlyRate: z.number().min(0, t('common:error.cannotBeNegative')).optional(),
  });
};

export type TeamMemberBillingFormData = z.infer<ReturnType<typeof teamMemberBillingSchema>>;
